const config = {
  VALIDERE_BRANDMARK_URL:
    "https://assets.validere.com/images/brand/validere-brandmark-dynamic.svg",
  DATE_FORMAT: "MMM DD, YYYY",
  TIME_FORMAT: "HH:mm:ss",
  DATETIME_FORMAT: "MMM DD, YYYY HH:mm",
  DATETIME_WITH_TIMEZONE_FORMAT: "MMM DD, YYYY HH:mm:ss z",
};

export default config;
